import React from 'react';

import './footer.scss';

import { Link } from 'react-router-dom';

import bg from '../../assets/footer-bg.jpg';
import logo from '../../assets/tmovie.png';

const Footer = () => {
    return (
        <div className="footer">
            Made with ❤️ by BISHAL RANJAN RAY
        </div>
    );
}

export default Footer;
